<div class="entity-list-container">
  <div class="header">
    <h1>{{ title() }}</h1>
    <button mat-raised-button color="primary" (click)="onCreate()">
      <mat-icon>add</mat-icon>
      Додати новий
    </button>
  </div>

  <div class="search-bar">
    <mat-form-field appearance="outline" class="search-field">
      <mat-label>Пошук</mat-label>
      <input
        matInput
        [formControl]="searchControl"
        (keyup.enter)="onSearch()"
        placeholder="Введіть текст для пошуку..."
      />
      <button mat-icon-button matSuffix (click)="onSearch()">
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field>

    <ng-content select="[appFilters]"></ng-content>
  </div>

  <div class="table-container">
    <table mat-table [dataSource]="data() ?? []" matSort (matSortChange)="onSortChange($event)">
      @for (column of columns() || []; track column.key) {
        <ng-container [matColumnDef]="column.key">
          <th mat-header-cell *matHeaderCellDef [mat-sort-header]="column.sortable ? column.sortKey : ''">
            {{ column.label }}
          </th>
          <td mat-cell *matCellDef="let element">
            @if (column.type === 'date') {
              {{ getColumnStringValue(element, column.key) | date: 'mediumDate' : undefined : 'uk-UA' }}
            } @else if (column.type === 'enum') {
              {{ getColumnStringValue(element, column.key) | lowercase | switchEnum: column.options }}
            } @else if (column.type === 'array') {
              {{ getColumnStringValue(element, column.key) }}
            } @else if (column.type === 'count-icon') {
              @let count = getCountValue(element, column.key);
              <span class="count-icon-cell" [matTooltip]="count + ' ' + column.label">
                <mat-icon [class.count-icon--empty]="count === 0">
                  {{ count > 0 ? column.iconWhenFilled : column.iconWhenEmpty }}
                </mat-icon>
                <span class="count-icon-value">{{ count }}</span>
              </span>
            } @else {
              {{ getColumnStringValue(element, column.key) }}
            }
          </td>
        </ng-container>
      }

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="actions-column">Дії</th>
        <td mat-cell *matCellDef="let element" class="actions-column">
          @for (rowAction of getCustomRowActions(element); track rowAction.type) {
            <button
              mat-icon-button
              [color]="rowAction.color ?? 'primary'"
              [matTooltip]="rowAction.tooltip ?? ''"
              (click)="onCustomAction(rowAction.type, element)"
            >
              <mat-icon>{{ rowAction.icon }}</mat-icon>
            </button>
          }
          <button mat-icon-button class="action-btn--edit" (click)="onEdit(element)" matTooltip="Редагувати">
            <mat-icon>edit</mat-icon>
          </button>
          @for (endAction of getEndRowActions(element); track endAction.type) {
            <button
              mat-icon-button
              class="action-btn--end"
              [color]="endAction.color ?? 'primary'"
              [matTooltip]="endAction.tooltip ?? ''"
              (click)="onCustomAction(endAction.type, element)"
            >
              <mat-icon>{{ endAction.icon }}</mat-icon>
            </button>
          }
          @if (shouldShowDelete(element)) {
            <button
              mat-icon-button
              class="action-btn--end action-btn--delete"
              (click)="onDelete(element)"
              matTooltip="Вилучити"
            >
              <mat-icon>delete</mat-icon>
            </button>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns()"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns()" [ngClass]="getRowClass(row)"></tr>

      <ng-template matNoDataRow>
        <tr class="no-data-row">
          <td [attr.colspan]="displayedColumns()?.length ?? 0">
            <div class="no-data">Немає даних</div>
          </td>
        </tr>
      </ng-template>
    </table>

    @if (loading()) {
      <div class="loading-overlay">
        <mat-spinner></mat-spinner>
      </div>
    }
  </div>

  <mat-paginator
    [length]="totalItems()"
    [pageSize]="pageSize()"
    [pageIndex]="pageIndex()"
    [pageSizeOptions]="[5, 10, 25, 50]"
    (page)="onPageChange($event)"
    showFirstLastButtons
  >
  </mat-paginator>
</div>
